import { render, staticRenderFns } from "./AppAttendanceTopButtons.vue?vue&type=template&id=060cec34&"
import script from "./AppAttendanceTopButtons.vue?vue&type=script&lang=js&"
export * from "./AppAttendanceTopButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports